// FormFour.js
import React, { useEffect } from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { useSelector } from "react-redux";
import {
	Popover,
	PopoverBody,
	PopoverHeader,
	Spinner,
	UncontrolledPopover
} from "reactstrap";
import renderCheckBoxField from "shared/components/form/CheckBox";
import dayjs from "dayjs";
import { MdInfoOutline } from "react-icons/md";
import TooltipComponent from "components/TooltipComponent";

const FormFour = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormFourSubmit,
		events
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("expositor_form");

	const loading = selector(state, "loading");
	const events2 = selector(state, "events2") || {};

	useEffect(() => {
		for (const e in events2) {
			props.change(`events[${e}]`, events2[e]);
		}
	}, []);

	const handleNextClick = async event => {
		event.preventDefault();
		handleSubmit(onFormFourSubmit);
	};

	return (
		<div>
			<form className="form" onSubmit={handleNextClick}>
				<div className="form__form-group">
					<div className="flex-center">
						<h3 className="account__title">Palestras</h3>
						<span>
							<a
								target="_blank"
								href="https://whatspro.s3.ca-central-1.amazonaws.com/5c5c8a1eb7516d4d4c52b208/in/Programa%C3%A7%C3%A3o%20FINAL-7.pdf"
							>
								Confira a programação completa aqui
							</a>
						</span>

						<br />
					</div>
					{/* <br /> */}
					<span className="form__form-group-label">
						Selecione as palestras que você pretende ir abaixo:
					</span>
					<br />
					{events
						// .filter(c => c._id === "667d6d10996e70a66d98c464")
						.map((event, index) => {
							const when = dayjs(event.when).format("DD/MM");
							const start = dayjs(event.when).format("HH:mm");
							const end = {
								"08:00": "12:00",
								"13:30": "18:00",
								"19:00": "22:00"
							}[start];

							let label = `${when} das ${start} às ${end} - ${event.title}`;
							if (
								event.title.indexOf("C1") !== -1 ||
								event.title.indexOf("D1") !== -1
							) {
								label = `${when} das ${start} às ${end} | 13:30 às 18:00 - ${event.title}`;
							}

							if (events2[event._id]) {
								event.attendees = event.capacity - 1; // Ajuste para mostrar como se já tivesse um inscrito e permitir a desmarcação
							}

							const soldOut = event.attendees >= event.capacity;

							if (soldOut) label = `Esgotado - ${label}`;

							// console.log(event._id, events2[event._id]);
							return (
								<div
									key={index}
									className="form__form-group-field"
									// style={{ justifyContent: "space-around" }}
								>
									<Field
										name={`events[${event._id}]`}
										component={renderCheckBoxField}
										type="text"
										label={label}
										disabled={soldOut}
										// value={events2[event._id]}
										// defaultChecked={events2[event._id]}
										// defaultValue={events2[event._id]}
										onChange={() => {
											if (soldOut) return;

											for (const e of events.filter(
												c => c.when === event.when
											)) {
												if (e._id === event._id) continue;

												props.change(`events[${e._id}]`, false);
											}
										}}
									/>
									<span
										id={`event_${event._id}`}
										style={{
											paddingLeft: 8,
											paddingRight: 8,
											cursor: "pointer",
											color: "#6bb567",
											minWidth: 70
										}}
									>
										Ver mais
									</span>

									<UncontrolledPopover
										placement="bottom"
										target={`event_${event._id}`}
										trigger="legacy"
									>
										<PopoverHeader>Programação</PopoverHeader>
										<PopoverBody
											dangerouslySetInnerHTML={{ __html: event.description }}
										></PopoverBody>
									</UncontrolledPopover>
								</div>
							);
						})}
				</div>

				{/* Campo oculto para enviar o status como 'ativo' */}
				{/* <Field name="status" component="input" type="hidden" value="ativo" /> */}

				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={previousPage}
					>
						Voltar
					</button>
					<button
						type="submit"
						className="btn btn-primary account__btn account__btn--small"
						disabled={pristine || submitting || loading}
					>
						{loading ? (
							<Spinner type="grow" size="sm" color="dark" />
						) : (
							"Cadastrar"
						)}
					</button>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: "expositor_form",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 4)
})(FormFour);
